import {Directive, ElementRef, OnDestroy, AfterViewInit, Renderer2} from '@angular/core';
import {environment} from "../env";

@Directive({
  selector: '[useImageProxy]',
  standalone: true
})
export class ProxyImageDirective implements AfterViewInit, OnDestroy {

  private observer?: MutationObserver;

  constructor(private el: ElementRef<HTMLImageElement>, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.applyProxy();

    // Watch for later src attribute changes (e.g. bound via [src])
    this.observer = new MutationObserver(() => this.applyProxy());
    this.observer.observe(this.el.nativeElement, { attributes: true, attributeFilter: ['src'] });
  }

  private applyProxy() {
    const img = this.el.nativeElement;
    // Prefer the attribute so we see the original bound value before resolution to absolute URL
    const attrSrc = img.getAttribute('src');
    const originalSrc = attrSrc ?? img.src ?? '';

    if (!originalSrc) return;

    // If already proxied, do nothing
    if (originalSrc.startsWith(environment.imageProxyUrl)) return;

    // Encode the original URL part to avoid issues with slashes/queries
    const encoded = encodeURIComponent(originalSrc);
    this.renderer.setAttribute(img, 'src', `${environment.imageProxyUrl}/${originalSrc}`);
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

}
